
























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { saveToCliboard } from '@/utils';

@Component({})
export default class ShortLinkComponent extends Vue {
    @Prop() public url: string;

    @Prop({default: 30}) public maxSize: number; // avoid = 30, use default instead

    @Prop({default: 'left'}) public direction: 'left' | 'right';

    @Prop({default: 'right'}) public positionIcon: 'left' | 'right';

    @Prop({default: false}) public onlyIcon: boolean;

    get shortUrl(): string {
        let str = '';
        if (!this.url) {
            return '';
        }
        if (this.url.length <= this.maxSize) {
            return this.url;
        }
        switch (this.direction) {
            case 'left': {
                const removeCount = Math.max(3, this.url.length - this.maxSize);
                str = '...' + this.url.substring(removeCount);
                break;
            }
            case 'right': {
                str = this.url.substring(0, this.maxSize) + '...';
                break;
            }
        }

        return str;
    }

    public save() {
        saveToCliboard(this.url);
    }
}
